module.exports = __webpack_public_path__ + "media/images/brands/tigor-page-b51aff295ce9d09ebb37e27df2bcb70b.png";